{
	"title": "Attributs du carbone capturé",
	"buttonTitle": "Captage et stockage du carbone",
	"table": {
		"materialDescription": "Matériau",
		"quantity": "Quantité",
		"productGwpTotal": "GWP total du produit",
		"bundledCarbonReductions": "Réductions carbone groupées",
		"remainingGwp": "GWP restant",
		"epdForPhysicalMaterial": "EPD pour le matériau physique",
		"carbonPlantName": "Brevik, Norvège"
	},
	"declarationDetailsBanner": {
		"rightfulHolderText": "est le titulaire légitime des réductions carbone déclarées."
	},
	"modal": {
		"title": "Captage et stockage du carbone",
		"description": "Le captage et stockage du carbone (CCS) est une technologie permettant de capter les émissions de dioxyde de carbone (CO2) produites par le processus de calcination et l’utilisation de combustibles lors de l’exploitation du four, empêchant le CO2 d’entrer dans l’atmosphère et le stockant de manière permanente sous terre. Le CO2 capté à l’usine Heidelberg Materials de Brevik, en Norvège, est compressé et transporté vers un site de stockage sous la mer du Nord. L’installation de notre site de Brevik captera 400 000 tonnes de CO2 par an.",
		"showLink": "En savoir plus sur le processus de captage du carbone",
		"buttonClose": "Fermer"
	},
	"footnote": "1) Les réductions carbone compensent les étapes A1-A3 de l’inventaire du cycle de vie du ciment."
}
